/*
 * @Description:
 * @Date: 2021-10-28 18:14:57
 */

import request from '@/tools/request';
const basePath = '/rest/cso/saas';

// 任务记录页面 - 专区的详情 - 月度详情
export const selectMonthTask = data =>
  request.post(`${basePath}/taskRecord/selectMonthTask`, data);

// 审核记录列表审核
export const auditOssStatus = data => {
  return request.post(`${basePath}/taskRecord/auditOssStatus`, data, {
    serviceLoading: true
  });
};
// 审核记录列表点击任务数弹窗批量审核
export const allAuditOssStatus = data => {
  return request.post(
    `${basePath}/taskRecord/auditOssStatusSonList/allAuditOssStatus`,
    data,
    {
      serviceLoading: true
    }
  );
};
// 任务记录全部选择
export const taskRecordListAll = data => {
  return request.post(`${basePath}/taskRecord/taskRecordListAll`, data, {
    serviceLoading: true
  });
};
export const Task = {
  // 新图片查重 /similar/findSimiForDetail
  findSimiForList(data) {
    return request.post(`${basePath}/similar/findSimiForList`, data);
  },
  // 新图片查重 /similar/findSimiForDetail
  findSimiForDetail(data) {
    return request.post(`${basePath}/similar/findSimiForDetail`, data);
  },
  // 任务记录-详情：可配置场景定位题快速比对
  locationMapComparison(data) {
    return request.post(`${basePath}/taskRecord/locationMapComparison`, data);
  },
  //刷新地图
  replaceMap(data) {
    return request.post(`${basePath}/taskRecord/replaceMap`, data);
  }
};
// 快捷审核
export const quickAudit = {
  // 详情审核
  audit(data) {
    return request.post('/rest/cso/saas/quickAudit/audit', data, {
      serviceLoading: true,
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 列表item审核
  auditStatus(data) {
    return request.post(`${basePath}/quickAudit/auditStatus`, data, {
      serviceLoading: true
    });
  },
  // 列表批量审核
  batchAudit(data) {
    return request.post(`${basePath}/quickAudit/batchAudit`, data, {
      serviceLoading: true
    });
  },
  getDisplayInfo(data) {
    return request.post(`${basePath}/quickAudit/getDisplayInfo`, data);
  },
  getDisplayInfoList(data) {
    return request.post(`${basePath}/quickAudit/list`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  //快捷审核-单选
  selectRecord(data) {
    return request.post(`${basePath}/quickAudit/selectRecord`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  //快捷审核-全选
  selectAllRecord(data) {
    return request.post(`${basePath}/quickAudit/selectAllRecord`, data, {
      serviceLoading: true,
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  getTaskSummaryList(data) {
    return request.post(`${basePath}/taskRecordSummary/list`, data);
  },
  getQueryCsoProjectNew(data) {
    return request.post(
      `${basePath}/taskRecordAndSummaryDoc/queryCsoProjectNew`,
      data
    );
  }
};
// 审核记录
export const auditRecord = {
  getList(data) {
    return request.post(`${basePath}/taskRecord/auditRecordList`, data);
  },
  //审核记录 - 操作人 - 下拉框
  getOperator(data) {
    return request.post(
      `${basePath}/taskRecord/auditRecordList/operator`,
      data
    );
  },
  //审核记录 - 通过/不通过操作
  edit(data) {
    return request.post(`${basePath}/taskRecord/auditRecordList/edit`, data);
  },
  //审核记录 - 点击-审核任务数列表
  auditOssStatusSonList(data) {
    return request.post(`${basePath}/taskRecord/auditOssStatusSonList`, data);
  }
};
// 快捷回复 审核不通过快捷回复
export const fastReply = {
  get: data => {
    //获取快捷回复列表：http://yapi.jimijiayuan.cn/project/657/interface/api/22475
    return request.post(`${basePath}/opinion/list`, data);
  },
  delete: data => {
    // 删除快捷回复信息 http://yapi.jimijiayuan.cn/project/657/interface/api/22481
    return request.post(`${basePath}/opinion/delete`, data);
  }
};
// 任务汇总
export const taskRecordSummary = {
  list(data) {
    return request.post(`${basePath}/taskRecordSummary/list`, data);
  }
};

// 操作日志
export const taskOptLogList = data =>
  request.post(`${basePath}/taskRecord/taskOptLogList`, data);

// 专区场景本次过期多少条任务记录数据
export const queryChannelUvTask = data =>
  request.post(`${basePath}/taskOverdue/queryChannelUvTask`, data);

// 单个任务记录设置过期
export const auditTaskOverdueListOne = data =>
  request.post(`${basePath}/taskOverdue/auditTaskOverdueList/one`, data);
